module.exports = __webpack_public_path__ + "img/赵瑞鑫.df9bd6a3.jpg";